import styled from 'styled-components'
import { Tooltip } from '@dsny/dsny-component-library'

export const StyledTooltip = styled(Tooltip).attrs(
  ({ theme, style, hidden }) => ({
    containerStyles: {
      fontSize: 12,
      fontFamily: 'Nunito Sans',
      padding: '4px 8px',
      margin: '-6px 0 0',
      borderRadius: 5,
      boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
      height: 'auto',
      display: hidden ? 'none' : 'flex',
      ...style
    },
    color: theme.extend.colors.white,
    backgroundColor: theme.extend.colors.neutralW50
  })
)``
